import {
  ADD_VLP_CUSTOM_CARD,
  FETCH_VLP_CUSTOM_CARDS,
  INITIALIZE_VLP_CUSTOM_CARD,
  STORE_VLP_CUSTOM_CARD_TO_EDIT,
  VLP_CUSTOM_CARD_UPDATE_STATUS
} from '../actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_VLP_CUSTOM_CARDS:
      console.log('Fetching VLP Custom Cards:', action.payload)
      return {
        ...state,
        ...action.payload
      }
    case INITIALIZE_VLP_CUSTOM_CARD:
      return {
        ...state,
        ...action.payload
      }
    case STORE_VLP_CUSTOM_CARD_TO_EDIT:
      return {
        ...state,
        ...action.payload
      }
    case ADD_VLP_CUSTOM_CARD:
      return {
        ...state,
        ...action.payload
      }
    case VLP_CUSTOM_CARD_UPDATE_STATUS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
